import { http } from "@/utils/http";
import qs from "qs";

export const fileUpload = {
  // 上传文件 返回网络地址
  upload(file, callback = () => { }, errorback = () => { }, fileType) {
    var formData = new FormData();
    formData.append("files", file);
    formData.append("unit", JSON.parse(sessionStorage.getItem('user')).unitId);
    //文件类型，1库区鸟瞰图，2入库图片，3出库图片，4入库检斤视频，5出库检斤视频，9其他
    if (fileType) {
      formData.append("fileType", fileType);
    }
    //分类码，GL称毛重时前摄像头照片，
    //GR称毛重时后摄像头照片
    //GT称毛重时顶摄像头照片
    //TL称皮重时前摄像头照片
    //TR称皮重时后摄像头照片
    //TT称皮重时顶摄像头照片
    //SL结算时摄像头拍取的售粮人照片
    //SF售粮人身份证照片
    http({
      url: "/sys-file2/upload2",
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        'token': sessionStorage.token,
      },
      data: formData,
    }).then((res) => {
      console.log("upload", res);
      callback(res)
    }).catch((error) => {
      errorback(error)
    });
  },
  // 上传文件
  uploadFunc(id, file, str, callback = () => { }, errorback = () => { }, fileType,note,weightType) {
    const formData = new FormData();
    formData.append("files", file);
    formData.append("formId", id);
    formData.append("moduleType", str);
    formData.append("unit", JSON.parse(sessionStorage.getItem('user')).unitId);
    if (fileType) {
      formData.append("fileType", fileType);
    }
    if (note) {
      formData.append("note", note);
    }
      // 0毛重，1皮重
    if (weightType===0||weightType===1) {
      formData.append("weightType", weightType);
    }
    http({
      url: '/sys-file2/upload',
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        'token': sessionStorage.token,
      },
      data: formData,
    }).then((res) => {
      console.log("uploadFunc", res);
      callback(res)
    }).catch((error) => {
      errorback(error)
    });
  },
  // 上传base64
  uploadbase64(id, base64, str, callback = () => { }, errorback = () => { }, fileType) {
    const formData = new FormData();
    formData.append("base64", base64);
    formData.append("formId", id);
    formData.append("moduleType", str);
    formData.append("unit", JSON.parse(sessionStorage.getItem('user')).unitId);
    if (fileType) {
      formData.append("fileType", fileType);
    }
    http({
      url: "/sys-file2/uploadByBase64",
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        'token': sessionStorage.token,
      },
      data: formData,
    }).then((res) => {
      callback(res)
    }).catch((error) => {
      errorback(error)
    });
  },
  // 多文件上传
  uploadFiles(id, file, str, callback = () => { }, errorback = () => { }, fileType,notes,url='/sys-file2/upload',weightType) {
    const formData = new FormData();
    file.forEach((item) => {
      formData.append('files', item)
    })
    formData.append("formId", id);
    formData.append("moduleType", str);
    formData.append("unit", JSON.parse(sessionStorage.getItem('user')).unitId);
    if (fileType) {
      formData.append("fileType", fileType);
    }
    if (notes) {
      notes.forEach((item) => {
        formData.append('notes', item)
      })
    }
    if (weightType===0||weightType===1) {
      // 0毛重，1皮重
      formData.append("weightType", weightType);
    }
    return http({
      url: url,
      method: "post",
      headers: {
        "Content-Type": "multipart/form-data",
        'token': sessionStorage.token,
      },
      data: formData
    }).then((res) => {
      console.log("uploadFiles", res);
      return callback(res)
    }).catch((error) => {
      return errorback(error)
    });
  },
  // 多文件流上传
  uploadFileStreams(id, file, str, callback = () => { }, errorback = () => { }, fileType,weightType) {
    const object = {}
    object.files = file
    object.formId = id
    object.moduleType = str
    object.unit = JSON.parse(sessionStorage.getItem('user')).unitId
    if (fileType) {
      object.fileType=fileType
    }
    if (weightType===0||weightType===1) {
      object.weightType=weightType
    }
    http({
      url: "/sys-file2/uploadByte",
      method: "post",
      headers: {
        'token': sessionStorage.token,
      },
      data: object
    }).then((res) => {
      console.log("uploadFiles", res);
      callback(res)
    }).catch((error) => {
      errorback(error)
    });
  },
  // 查询文件
  findFile(id, str, callback = () => { }) {
    let findData = [
      { column: "form_id", type: "eq", value: id },
      { column: "module_type", type: "eq", value: str }
    ];
    http({
      url: "/sys-file2/all",
      method: "post",
      headers: {
        'token': sessionStorage.token,
      },
      data: qs.stringify({ paramData: JSON.stringify(findData), }),
    }).then((res) => {
      if (res.data.code == 200) {
        callback(str, res)
      } else {
        this.$message.error(res.data.msg);
      }
    });
  },
  // 删除文件
  delFile(id, callback = () => { }, errorback = () => { }) {
    if (id) {
      return http({
        url: "/sys-file2/del",
        method: "post",
        headers: {
          'token': sessionStorage.token,
        },
        data: qs.stringify({
          ids: id,
        }),
      }).then((res) => {
        callback(res)
      }).catch((error) => {
        errorback(error)
      })
    }
  }
}
